/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="82.3"
        height="67.16"
        viewBox="0 0 82.3 67.16"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M26.08 0a14.13 14.13 0 1 0 14.13 14.13A14.13 14.13 0 0 0 26.08 0Zm0 2.5a11.63 11.63 0 1 1-11.63 11.63A11.63 11.63 0 0 1 26.08 2.5ZM32 36.56a1.25 1.25 0 0 1 .13 2.49H13.45a11 11 0 0 0-11 10.66v2.1a1.25 1.25 0 0 1-1.37 1.11A1.26 1.26 0 0 1 0 52v-2a13.46 13.46 0 0 1 13.14-13.44ZM60 22.56a22.3 22.3 0 1 0 22.3 22.3A22.3 22.3 0 0 0 60 22.56Zm0 2.5a19.8 19.8 0 1 1-19.8 19.8A19.79 19.79 0 0 1 60 25.06Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M52.11 36.94a1.22 1.22 0 0 1 1.66-.09l.1.09 14 13.94a1.25 1.25 0 0 1-1.67 1.86l-.1-.09-13.94-13.94a1.27 1.27 0 0 1 0-1.77Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M66.05 36.94a1.25 1.25 0 0 1 1.86 1.66l-.09.1-14 14a1.24 1.24 0 0 1-1.76 0 1.28 1.28 0 0 1-.1-1.7l.09-.1Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'PersonWithXCircleIcon';

export default Icon;
